import type { Follow } from "@tandemdiabetes/sugarmate-api-react-client"
import { ActionLink } from "@tandemdiabetes/sugarmate-react-components"
import { Link } from "@tanstack/react-router"
import { useCallback } from "react"

import styles from "../Onboarding.module.scss"
import { OnboardingPageTemplate } from "src/components"
import {
  usePolyglot,
  useFollowedUsers,
} from "src/contexts"
import {
  useDebouncedUpdater,
  useUpdateFollow,
} from "src/hooks"
import { NormalRange } from "src/pages/Settings/Ranges/NormalRange"
import sharedStyles from "src/pages/Settings/Ranges/Ranges.module.scss"
import { SleepHours } from "src/pages/Settings/Ranges/SleepHours"
import { UrgentLow } from "src/pages/Settings/Ranges/UrgentLow"

const polyglotPrefix = "pages.onboarding.ranges."
const settingsPolyglotPrefix = "pages.settings.ranges."

export function Ranges() {
  const polyglot = usePolyglot()

  const { currentFollow } = useFollowedUsers()
  const followId = currentFollow.id
  const followUpdatedAt = currentFollow.updated_at

  // TODO catch error and show toast
  const updateFollow = useUpdateFollow()
  const debouncedUpdateFollow = useDebouncedUpdater({ updater: updateFollow })

  const debouncedUpdateFollowWithId = useCallback(
    (follow: Partial<Follow>) => debouncedUpdateFollow({
      id: followId,
      ...follow,
    }),
    [
      debouncedUpdateFollow,
      followId,
    ],
  )

  return (
    <OnboardingPageTemplate
      backRoutePath="/onboarding/data_source"
      title={polyglot.t(`${polyglotPrefix}title`)}
    >
      <div className={styles.container}>
        <div className={sharedStyles.description}>
          {polyglot.t(`${settingsPolyglotPrefix}description`)}
        </div>
        <NormalRange
          updatedAt={followUpdatedAt}
          updateFollow={debouncedUpdateFollowWithId}
        />
        <UrgentLow
          updatedAt={followUpdatedAt}
          updateFollow={debouncedUpdateFollowWithId}
        />
        <SleepHours
          updatedAt={followUpdatedAt}
          updateFollow={debouncedUpdateFollowWithId}
        />
        <ActionLink
          asChild
          className={styles.submitCta}
        >
          <Link
            to="/onboarding/phone_call_alerts"
            id="skip-button"
          >
            {polyglot.t(`${polyglotPrefix}next_cta`)}
          </Link>
        </ActionLink>
      </div>
    </OnboardingPageTemplate>
  )
}
